import { render, staticRenderFns } from "./selectedData.vue?vue&type=template&id=7e865785&scoped=true&"
import script from "./selectedData.vue?vue&type=script&lang=js&"
export * from "./selectedData.vue?vue&type=script&lang=js&"
import style0 from "./selectedData.vue?vue&type=style&index=0&id=7e865785&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e865785",
  null
  
)

export default component.exports